import { useEffect, useState } from "react";
import PermissionGate from "../../layout/PermissionGate";
import axios from "axios";
import { isNumeric } from "validator";

const DriverMaxOrderScanLimit = ({
  id,
  setAlertConfig,
  fetchDriverDetails,
  data,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(0);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");

  const updateLimit = async () => {
    const value = Number(limit);

    if (!Number.isInteger(value) || value < 0 || value > 100) {
      setError("Please enter a valid number (0-100)");
      return;
    }

    setError("");
    setIsLoading(true);

    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_API_ENDPOINT}update-driver-max-order-scan/${id}`,
        { maxOrderScan: value },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.data.code === 1) {
        setAlertConfig({
          show: true,
          message: res.data.message,
          type: "success",
        });
        fetchDriverDetails();
      } else {
        setAlertConfig({
          show: true,
          message: res.data.message,
          type: "danger",
        });
      }
    } catch (err) {
      console.error(err);
      setAlertConfig({
        show: true,
        message: "Something went wrong",
        type: "danger",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data?.maxOrderScan === undefined || data?.maxOrderScan === null) return;
    setLimit(data?.maxOrderScan);
  }, [data?.maxOrderScan]);

  return (
    <PermissionGate required={`change_driver_max_order_scan_limit`}>
      <div className="card py-10">
        <div className="d-block d-md-flex justify-content-between px-10">
          <div className="fs-2 fw-thin">Scan Limit ---</div>
          <div className="d-flex mb-0 justify-content-end gap-2 mt-2">
            <div>
              <input
                onChange={(e) => {
                  setLimit(e.target.value);
                  setError("");
                }}
                type="text"
                className="form-control"
                value={limit ?? 0}
              />
              <small className="text-danger">{error}</small>
            </div>
            <button
              onClick={updateLimit}
              disabled={isLoading}
              className="btn btn-primary text-nowrap d-flex align-items-center justify-content-center"
              style={{ minWidth: "230px" }}
            >
              {isLoading && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              Change Scan Limit
            </button>
          </div>
        </div>
      </div>
    </PermissionGate>
  );
};

export default DriverMaxOrderScanLimit;
